<template>
    <div class="header">
        <div v-if="isBack" @click="toBack" class="header--back">
            {{ backName }}
        </div>
        <div class="header--title">{{ title }}</div>
        <div class="header__date">
            <div class="header__date--day">{{ time[0] }}</div>
            <div class="header__date--hour">{{ time[1] }}</div>
            <div class="header__date--week">{{ time[2] }}</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        isBack: {
            type: Boolean,
            default: false
        },
        backName: {
            type: String,
            default: '返回首页'
        },
        jump: {
            type: String,
            default: 'fc-screen'
        },
        title: {
            type: String,
            default: '丰城市农事服务大数据平台'
        }
    },
    data() {
        return {
            timerDate: null,
            time: ['', '', '']
        }
    },
    methods: {
        setTime() {
            const filling = (n) => (n >= 10 ? n : `0${n}`)
            const t = new Date()
            this.time = [
                `${t.getFullYear()}-${filling(t.getMonth() + 1)}-${filling(
                    t.getDate()
                )}`,
                `${filling(t.getHours())}:${filling(t.getMinutes())}:${filling(
                    t.getSeconds()
                )}`,
                [
                    '星期天',
                    '星期一',
                    '星期二',
                    '星期三',
                    '星期四',
                    '星期五',
                    '星期六'
                ][t.getDay()]
            ]
        },
        toBack() {
            const {
                jump,
                $route: {
                    query: { id, mode, tag }
                }
            } = this
            if (tag === 'fc-screen') {
                if (jump === 'fc-screen') {
                    this.$router.push({ name: jump, query: { id } })
                } else {
                    this.$router.push({ name: jump, query: { id, mode, tag } })
                }
            } else {
                this.$router.push({ name: jump })
            }
        }
    },
    mounted() {
        this.setTime()
        this.timerDate = setInterval(() => {
            this.setTime()
        }, 1000 * 1)
    },
    destroyed() {
        clearInterval(this.timerDate)
    }
}
</script>
<style lang="scss" scoped>
.header {
    width: 100%;
    height: 76px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center top;
    background-image: url('../assets/images/home_header_bg.png');
    position: relative;
    flex-shrink: 0;
    &--back {
        font-size: 18px;
        color: #64d5ff;
        position: absolute;
        top: 10px;
        left: 12px;
        cursor: pointer;
        z-index: 1;
    }
    &--title {
        line-height: 76px;
        text-align: center;
        font-size: 42px;
        color: #ffffff;
        letter-spacing: 1.15px;
        text-align: center;
        position: relative;
        top: -5px;
    }
    &__date {
        font-size: 18px;
        color: #64d5ff;
        height: 25px;
        top: 7.5px;
        line-height: 25px;
        position: absolute;
        right: 22px;
        display: flex;
        align-items: center;
        &--hour {
            margin: 0 16px;
        }
    }
}
</style>
